module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_e/logo-aoj-ja-d2de0f900266cfbf47cc9d46cee2b6e4.svg";